export default {"src":"/_next/static/media/btc.9716c952.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};